var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 73,
    viewBox: "0 0 94 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-2.98669 0C-7.41324 0 -11 3.46014 -11 7.73043V65.2696C-11 69.5399 -7.41324 73 -2.98669 73H85.9867C90.4132 73 94 69.5399 94 65.2696V7.73043C94 3.46014 90.4132 0 85.9867 0H-2.98669ZM26.8004 64.8923H-2.61808V56.7816H18.396V48.6739H5.78949V40.5662H26.8004V64.8923ZM85.5924 64.8923H35.208V56.7816H77.1881V48.6739H64.7066V40.5662H85.5924V64.8923ZM56.174 40.5662V48.6739H35.2881V40.5415H43.6957V40.5662H56.174ZM56.1996 8.10768H77.2105V16.2154H64.604V24.323H85.6181V32.4338H56.1996V8.10768ZM26.826 8.10768H39.3044V8.08294H47.7119V16.2154H26.826V8.10768ZM-2.59243 8.10768H18.2935V16.2154H5.81193V24.323H47.7921V32.4338H-2.59243V8.10768Z",
    fill: "#AF2D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector3.4b7a861a0db68b3920d53870a51cf986.svg";
export { ForwardRef as ReactComponent };